import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Alert,
  Tabs,
  Tab,
  TextField,
  Select,
  ListItemText,
  ListItemIcon,
  MenuItem,
  Slider,
  InputLabel,
  FormControl,
  Card,
  CardContent,
  CircularProgress,
  ListSubheader
} from "@mui/material";
import { FileUploader } from "react-drag-drop-files";
import { uploadVoiceOverFile } from "../../apis/apiList/projectApi";
import { useMessage } from "../../context/MessageContext";
import { useApp } from "../../context/AppContext";
import axios from "axios";
import { UploadFile, GraphicEq } from "@mui/icons-material";
import MicIcon from "@mui/icons-material/Mic";
import CheckIcon from "@mui/icons-material/Check";
import VibeSelector from "./vibeSelector";
import { createTextToSpeech, getVODetailByProjectId } from "../../apis/apiList/ttsApi";
import VoiceList from "./VoiceList";
import socket from "../../services/socket";

const fileTypes = [ 
  "mp3",
  "wav",
  "aac",
  "ogg",
  "flac",
  "m4a",
  "wma",
  "alac",
  "opus",
  "aiff",
  "pcm",
  "amr",
];

const voiceOptions = [
  {
    id: "PE0000",
    name: "Tom",
    gender: "Young, Male",
    description: "Authoritative and deep. Middle-aged Male with American accent. An authorative and deep voice. Great for audiobooks or news.",
  },
  {
    id: "PE0001",
    name: "Alex",
    gender: "Young, Male",
    description: "Expressive narrator Young Male with American accent. Young american man. Is a strong and expressive narrator.",
  },
  {
    id: "PE0002",
    name: "Lisa",
    gender: "Young, Female",
    description: "Valley girl Young Female with American accent A valley girl female voice. Great for shorts.",
  },
  {
    id: "PE0003",
    name: "Mia",
    gender: "Old, Female",
    description: "Calm & composed Old Female with American accent An old American female voice with calm and composed",
  },
  {
    id: "PE0004",
    name: "Theresa",
    gender: "Young, Female",
    description: "Young and Soft Young Female with American accent A young female with a softly spoken tone, perfect for storytelling or ASMR.",
  },
  {
    id: "PE0005",
    name: "Ella",
    gender: "Young, Female",
    description: "Pensive, introspective, soft and lovely Young Female with American accent Young american woman. A soft and pleasent voice for a great character.",
  },
  {
    id: "PE0006",
    name: "Neal",
    gender: "Middle Aged, Male",
    description: "Vibrant and baritone Middle-aged Male with American accent . A vibrant baritone voice. Good for shorts and narration",
  },
  {
    id: "PE0007",
    name: "Lizzy",
    gender: "Young, Female",
    description: "Young girl Young Female with American accent A gentle but confience young woman's voice with an American accent. Would work well in a conversation.",
  },
  {
    id: "PE0008",
    name: "Brian",
    gender: "Old, Male",
    description: "Old Male with American accent. A deep, strong old male American accent. Great for narration.",
  },
  {
    id: "PE0009",
    name: "Joanne",
    gender: "Middle Aged, Female",
    description: "Excited Middle-aged Female with American accent A conversational and excited voice. Good for podcasts.",
  },
  {
    id: "PE0040",
    name: "Samantha",
    gender: "Young, Female",
    description: "Young Female with Australian accent. Playful and energetic voice, suitable for animated characters or educational content for children.",
  },
  {
    id: "PE0041",
    name: "Max",
    gender: "Young, Male",
    description: "Expressive and wise Young Male with Australian accent. Young Australian man. Has a relaxed tone, for a good narrator.",
  },
  {
    id: "PE0042",
    name: "Eve",
    gender: "Middle Aged, Female",
    description: "Direct and Understanding Middle-aged Female with Australian accent. A woman with a direct and understanding voice, perfect for media creation and voiceovers.",
  },
  {
    id: "PE0043",
    name: "Miriam",
    gender: "Young, Female",
    description: "Sweet and Soft Young Female with Australian accent. A young girl with a sweet and soft tone, perfect for casual conversation.",
  },
  {
    id: "PE0044",
    name: "Phoebe",
    gender: "Middle Aged, Female",
    description: "Very confident and collected Middle-aged Female with Australian accent. A very confident and strong voice with a slight Australian accent. Great for coaching.",
  },
  {
    id: "PE0045",
    name: "Elena",
    gender: "Young, Female",
    description: "Curious and Soft Young Female with Australian accent. A young woman with a curious and soft tone, great for conversations and casual speech.",
  },
  {
    id: "PE0046",
    name: "Bella",
    gender: "Middle-aged, Female",
    description: "Casual and Wry Middle-aged Female with Australian accent. Voice is low, smooth and casual. Great for conversations.",
  },
  {
    id: "PE0047",
    name: "Belinda",
    gender: "Young, Female",
    description: "Young Australian girl. A younger female voice with a slight vocal fry. Great for content that requires an attitude.",
  },
  {
    id: "PE0048",
    name: "Miri",
    gender: "Young, Female",
    description: "Teen and Focused Young Female with Australian accent. A young teen girl with a focused tone, perfect for conversations or casual speech.",
  },
  {
    id: "PE0049",
    name: "Beatrice",
    gender: "Young, Female",
    description: "Young Female with Australian accent. A young excited female voice.",
  },
  {
    id: "PE0050",
    name: "John",
    gender: "Old, Male",
    description: "Deep, classical Old Male with Australian accent. Old Australian man. A classical American news broadcaster.",
  },
  {
    id: "PE0051",
    name: "Max",
    gender: "Young, Male",
    description: "Young Male with Australian accent. A young male Australian voice. Great for news broadcasting.",
  },
  {
    id: "PE0052",
    name: "Lee",
    gender: "Young, Female",
    description: "Young Female with Australian accent. Young Australian woman. Has a soothing tone for good conversations.",
  },
  {
    id: "PE0053",
    name: "Dean Jones",
    gender: "Middle-aged, Male",
    description: "High energy, great character Middle-aged Male with Australian accent. Middle-aged Australian man. A confident voice for conversations.",
  },
  {
    id: "PE0054",
    name: "Margot",
    gender: "Young, Female",
    description: "Calm and slow Young Female with Australian accent. A very pleasant voice with a slight vocal fry. A somewhat reflective tone. Great for characters.",
  },
  {
    id: "PE0055",
    name: "Ava",
    gender: "Middle-aged, Female",
    description: "Middle-aged Female with Australian accent. A voice suitable for short video content.",
  },
  {
    id: "PE0056",
    name: "Margareth",
    gender: "Male",
    description: "Middle-aged Male with Australian accent An Australian voice with a strong and full timbre.",
  },
  {
    id: "PE0057",
    name: "Cecilia",
    gender: "Male",
    description: "Aged Australian Male Middle-aged Male with Australian accent An Old Australian Male, eLearning Narrator. with a Conversational, Warm, and friendly voice. Perfect for Informative. Educational content.",
  },
  {
    id: "PE0058",
    name: "Helena",
    gender: "Female",
    description: "Old Female with Australian accent A strong and mature voice.",
  },
  {
    id: "PE0059",
    name: "Henry",
    gender: "Male",
    description: "Middle-aged Male with Australian accent A confident and clear voice.",
  },
   {
    id: "PE0231",
    name: "Oliver",
    gender: "Male",
    description: "Young Australian man. Has a relaxed tone, for a good narrator."
  },
  {
    id: "PE0233",
    name: "William",
    gender: "Male",
    description: "Fast paced, deep & serious Australian Documentary Narrator for dramatic subjects. For TV, News, Radio, YouTube & Social Media. True Crime Australia, Shocking Border Security Dramas and Aussies Abroad Gone Rogue!"
  },
  {
    id: "PE0235",
    name: "Charlie",
    gender: "Male",
    description: "A smooth, articulate Australian male voice with a warm, inviting quality and a confident, professional edge. Suitable for Conversations."
  },
  {
    id: "PE0237",
    name: "Lucas",
    gender: "Male",
    description: "A 40-year-old Australian male He speaks with a softer Australian accent, not the broad, stereotypical twang often associated with the Outback, but rather a gentler, more refined tone that reflects his maturity and sophistication."
  },
  {
    id: "PE0238",
    name: "Elijah",
    gender: "Male",
    description: "Soft Australian Baritone - versatile, articulate, high-quality studio audio read at a slow, soothing pace.",
  },
  {
    id: "PE0239",
    name: "Ava",
    gender: "Female",
    description: "A sweet sounding Australian woman in her 20s. Perfect for Storytelling.",
  },
  {
    id: "PE0240",
    name: "Chloe",
    gender: "Female",
    description: "Female Australian, teenager/childish voice. Suitable for young-adult narration and school lessons.",
  }
  
];
;
// const voiceOptions = [
//   {
//     id: "OA001",
//     name: "Alloy",
//     gender: "Male",
//     description: "Neutral, professional, and clear",
//   },
//   {
//     id: "OA002",
//     name: "Echo",
//     gender: "Male",
//     description: "Warm, friendly, and engaging",
//   },
//   {
//     id: "OA003",
//     name: "Fable",
//     gender: "Male",
//     description: "Energetic, expressive, and engaging",
//   },
//   {
//     id: "OA004",
//     name: "Onyx",
//     gender: "Male",
//     description: "Older, mature, and experienced",
//   },
//   {
//     id: "OA005",
//     name: "Nova",
//     gender: "Female",
//     description: "Young, energetic, and engaging",
//   },
//   {
//     id: "OA006",
//     name: "Shimmer",
//     gender: "Female",
//     description: "Lively, vibrant, and dynamic",
//   },
//   {
//     id: "OA007",
//     name: "Ash",
//     gender: "Male",
//     description: "Enthusiastic, energetic, and lively",
//   },
//   {
//     id: "OA009",
//     name: "Coral",
//     gender: "Female",
//     description: "Cheerful, friendly, and community-oriented",
//   },
//   {
//     id: "OA010",
//     name: "Sage",
//     gender: "Female",
//     description: "Wise, calm, and knowledgeable",
//   },
// ];


// const models = [
//   { value: 'standard', label: 'Standard' },
//   { value: 'high', label: 'High Quality' },
// ];

const models = [
  { value: "tts-1", label: "Standard quality" },
  { value: "tts-1-hd", label: "High quality" },
];

const CreateVoiceOverStage = ({
  project,
  setProject,
  setApprovedVoiceOverFileId,
}) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const { showMessage } = useMessage();
  const { userDetails } = useApp();
  const [projectDetail, setProjectDetail] = useState(project);

  const [tabIndex, setTabIndex] = useState(0);

  const [text, setText] = useState("");
  const [voice, setVoice] = useState(voiceOptions[0].id);
  const [model, setModel] = useState(models[0].value);
  const [speed, setSpeed] = useState(1);
  const [isGenerating, setIsGenerating] = useState(false);
  const [vibeSelect, setVibeSelect] = useState(26);
  const [isGeneratedSpeechInProgress, setIsGeneratedSpeechInProgress] = useState(false);
  const [voiceOverDetails, setVoiceOverDetails] = useState({});
  const [recentlyUsedVoices, setRecentlyUsedVoices] = useState([]);
  const [allOtherVoices, setAllOtherVoices] = useState([]);

  useEffect(() => {
    async function getProjectDetail() {
      try{
        const VODetails = await getVODetailByProjectId(project._id);
        console.log('VODetails', VODetails);
        setVoiceOverDetails(VODetails.voiceOver);
        const previousVoiceId = VODetails?.voiceOver?.voiceId;
        console.log("previousVoiceId", previousVoiceId)
        if(previousVoiceId){
          setVoice(previousVoiceId)
        }
        handlePreviouslyUsedVoice(previousVoiceId);
      } catch (err) {
        console.error('err?.response', err?.response);
        handlePreviouslyUsedVoice();
        // showMessage(err?.response?.data?.error, "error");
      }
    }
    getProjectDetail();
    
    if(project.topics && project.topics.length > 0){
    console.log("project.topics", project.topics);
    const mergedTextForSpeech = project.topics
        .filter((t) => t.content.trim() !== "") // skip empty
        .map((t) => t.content.trim())           // get only the text
        .join("\n\n");                       // separate topics with line breaks

        setText(mergedTextForSpeech);
    }

    socket.on('voiceOverGenerated', (data) => {
      console.log('voiceOverGenerated', data);
      setVoiceOverDetails(data.voiceOver);
      // setProjectDetail( { ...projectDetail, approvedVoiceOverFileId: data.approvedVoiceOverFileId });
      // setProject( { ...projectDetail, approvedVoiceOverFileId: data.approvedVoiceOverFileId });
      setProjectDetail(prev => ({
        ...prev,
        approvedVoiceOverFileId: data.projectInfo.approvedVoiceOverFileId,
      }));
      setProject(prev => ({
        ...prev,
        approvedVoiceOverFileId: data.projectInfo.approvedVoiceOverFileId,
      }));
      showMessage('Voice over generated', 'success');
    })
  }, [])

  useEffect(() => {

    const handleVoiceOverFailed = (data) => {
      console.log('voiceOverFailed', data);
      if (data.voiceOver.userId == userDetails._id) {
        showMessage('Failed to generate voice over.', 'error');
      }
    }
    socket.on('voiceOverFailed', handleVoiceOverFailed);
  }, [])

  const handleChangeText = (e) => {
    const value = e.target.value;
    if (value.length <= 10000) {
      setText(value);
      setError(false);
    } else {
      setError(true);
    }
  };

  const generateAudio = async () => {
    setIsGenerating(true);
    try {
      // API call here
      const ttsResponse = await createTextToSpeech({ text, voice_id: voice, projectId: projectDetail._id, userId: userDetails._id, vibeId: vibeSelect });
      console.log('ttsResponse', ttsResponse);
      if(ttsResponse.data.status == 'pending') {
        setIsGeneratedSpeechInProgress(true)
        setVoiceOverDetails(ttsResponse.data);
      }
      handlePreviouslyUsedVoice(ttsResponse?.data?.voiceId)
      setIsGenerating(false);
      showMessage("Audio will generate soon", "success");
    } catch (err) {
      console.error('err?.response', err?.response);
      showMessage(err?.response?.data?.error, "error");
      setIsGenerating(false);
    }
  };
  const handleChange = (file) => {
    setFile(file);
  };

  const handleFileUpload = async () => {
    setIsSubmit(true);
    if (!file) {
      setError("Please upload file");
      setIsSubmit(false);
      return;
    }
    setError("");

    try {
      const formData = new FormData();

      formData.append("audioFile", file);

      const projectNew = await uploadVoiceOverFile(project._id, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": userDetails?.jwtToken,
        },
      });
      let newProject = { ...projectDetail };

      newProject.approvedVoiceOverFileId =
        projectNew.data.approvedVoiceOverFileId;
      setApprovedVoiceOverFileId(projectNew.data.approvedVoiceOverFileId);
      setProjectDetail(newProject);
      setProject(newProject);
      setIsSubmit(false);
      setFile(null);
      showMessage(projectNew.message, "success");
    } catch (err) {
      setIsSubmit(false);
      showMessage(
        err?.response?.data?.message || "Internal server issue",
        "error"
      );
    }
  };

  const handleVibeSelect = (vibe) => {
    console.log('vibe', vibe);
    setVibeSelect(vibe.id);
  }

  const handlePreviouslyUsedVoice = async (previousVoiceId)=>{
    const previousVoice = voiceOptions.filter(v => v.id == previousVoiceId);
    console.log("previousVoice", previousVoice)
    setRecentlyUsedVoices(previousVoice);
    const otherVoices = voiceOptions.filter(v => v.id != previousVoiceId);
    console.log("otherVoices", otherVoices)
    setAllOtherVoices(otherVoices);
  }
  

  return (
    <>
      {userDetails && userDetails.role == "admin" && (
        <>
          
          <Box sx={{ width: "100%", bgcolor: "#fff", borderRadius: 2, mb: 3 }}>
            <Tabs
              value={tabIndex}
              onChange={(e, val) => setTabIndex(val)}
              variant="fullWidth"
              sx={{
                minHeight: "40px",
                ".MuiTabs-flexContainer": {
                  // borderBottom: '2px solid #ccc',
                },
                ".MuiTab-root": {
                  minHeight: "40px",
                  py: "6px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#444",
                  // backgroundColor: '#f9f9f9',
                  backgroundColor: "#ebebeb",
                  borderRadius: "6px 6px 0 0",
                  mx: 0.5,
                  textTransform: "none",
                  "&.Mui-selected": {
                    backgroundColor: "#fff",
                    color: "#d32f2f",
                    borderBottom: "2px solid #d32f2f",
                  },
                },
                ".MuiTabs-indicator": {
                  display: "none",
                },
              }}
            >
              <Tab
                icon={<UploadFile fontSize="small" />}
                iconPosition="start"
                label="Upload Voice File"
              />
              <Tab
                icon={<GraphicEq fontSize="small" />}
                iconPosition="start"
                label="Generate Text To Speech"
              />
            </Tabs>
          </Box>
          {tabIndex === 0 && (
            <Box className="fileUpload-stage">
              <FileUploader
                handleChange={handleChange}
                name="file"
                multiple={false}
                types={fileTypes}
                fileOrFiles={file}
                uploadedLabel={`File selected: ${file?.name}.  Click Upload to start uploading.`}
              />
              {error && <Typography color="red">{error}</Typography>}

              <Button
                variant="contained"
                sx={{ marginTop: "15px" }}
                disabled={isSubmit || projectDetail.approvals.voiceOver}
                onClick={handleFileUpload}
              >
                {" "}
                {isSubmit ? "Uploading..." : "Upload"}
              </Button>
            </Box>
          )}
          {tabIndex === 1 && (
            <Box>
              <Card variant="outlined" sx={{ mb: 4, border: "none" }}>
                
                <Box display="flex" flexDirection="column" gap={3}>
                  {/* Text Input */}
                  <Box>
                    <Typography
                      variant="subtitle1"
                      color="text.primary"
                      gutterBottom
                    >
                      Text to Convert
                    </Typography>
                    <TextField
                      className={"topic-text"}
                      multiline
                      fullWidth
                      minRows={10}
                      placeholder="Enter the text you want to convert to speech..."
                      value={text}
                      onChange={(e) => handleChangeText(e)}
                      error={error}
                      helperText={
                        error
                          ? "Only 10,000 characters can be converted."
                          : `${text.length} characters (max 10,000)`
                      }
                    />
                  </Box>

                  {/* Voice and Model Selection */}
                  <Box
                    display="flex"
                    flexDirection={{ xs: "column", md: "row" }}
                    gap={2}
                  >
                      {/* <FormControl fullWidth>
                          <InputLabel>Voice</InputLabel>
                          <Select
                            value={voice}
                            label="Voice"
                            onChange={(e) => setVoice(e.target.value)}
                            renderValue={(selected) => {
                                const selectedVoice = voiceOptions.find(
                                (v) => v.id === selected
                                );
                                return `${selectedVoice.name} – (${selectedVoice.gender}), ${selectedVoice.description}`;
                            }}
                          >
                          {voiceOptions.map((v) => {
                              const isSelected = voice === v.id;
                              return (
                              <MenuItem
                                  key={v.id}
                                  value={v.id}
                                  sx={{
                                  bgcolor: isSelected
                                      ? "rgba(25, 118, 210, 0.1)"
                                      : "inherit",
                                  display: "flex",
                                  textWrap: 'auto',
                                  width: '700px'
                                  // justifyContent: 'space-between',
                                  }}
                              >
                                  <ListItemIcon sx={{ minWidth: 32 }}>
                                  {isSelected ? (
                                      <CheckIcon fontSize="small" color="primary" />
                                  ) : (
                                      <Box width={18} height={18} /> 
                                  )}
                                  </ListItemIcon>
                                  <Typography>
                                  {v.name} – ({v.gender}), {v.description}
                                  </Typography>
                              </MenuItem>
                              );
                          })}
                          </Select>
                      </FormControl> */}

                      <FormControl>
                        <InputLabel>Voice</InputLabel>
                        <Select
                          value={voice}
                          label="Voice"
                          onChange={(e) => setVoice(e.target.value)}
                          renderValue={(selected) => {
                            const selectedVoice = voiceOptions.find(v => v.id === selected);
                            return selectedVoice
                              ? `${selectedVoice.name} – (${selectedVoice.gender}), ${selectedVoice.description}`
                              : "Select a voice";
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                width: '900px',
                                left: '6% !important'
                              }
                            }
                          }}
                        >
                          
                          {recentlyUsedVoices.length > 0 && [
                            <ListSubheader key="recent-header" disableSticky sx={{ pl: 2 }}>
                              Previously Used
                            </ListSubheader>,
                            ...recentlyUsedVoices.map((v) => {
                              const isSelected = voice === v.id;
                              return (
                                <MenuItem
                                  key={v.id}
                                  value={v.id}
                                  sx={{
                                    bgcolor: isSelected ? "rgba(25, 118, 210, 0.1)" : "inherit",
                                    pl: 2,
                                    pr: 2,
                                    width: "100%",
                                    textWrap: "auto"
                                  }}
                                >
                                  <ListItemIcon sx={{ minWidth: 32 }}>
                                    {isSelected ? (
                                      <CheckIcon fontSize="small" color="primary" />
                                    ) : (
                                      <Box width={18} height={18} />
                                    )}
                                  </ListItemIcon>
                                  <Typography>
                                    {v.name} – ({v.gender}), {v.description}
                                  </Typography>
                                </MenuItem>
                              );
                            })
                          ]}

                          {allOtherVoices.length > 0 && [
                            <ListSubheader key="all-header" disableSticky sx={{ pl: 2, mt: 1 }}>
                              All Voices
                            </ListSubheader>,
                            ...allOtherVoices.map((v) => {
                              const isSelected = voice === v.id;
                              return (
                                <MenuItem
                                  key={v.id}
                                  value={v.id}
                                  sx={{
                                    bgcolor: isSelected ? "rgba(25, 118, 210, 0.1)" : "inherit",
                                    pl: 2,
                                    pr: 2,
                                    width: "100%",
                                    textWrap: "auto"
                                  }}
                                >
                                  <ListItemIcon sx={{ minWidth: 32 }}>
                                    {isSelected ? (
                                      <CheckIcon fontSize="small" color="primary" />
                                    ) : (
                                      <Box width={18} height={18} />
                                    )}
                                  </ListItemIcon>
                                  <Typography>
                                    {v.name} – ({v.gender}), {v.description}
                                  </Typography>
                                </MenuItem>
                              );
                            })
                          ]}
                        </Select>
                      </FormControl>
                      
                      <FormControl sx={{ width: "70%" }}>
                          <VibeSelector handleVibeSelect={handleVibeSelect}/>
                      </FormControl>
                  </Box>

                  {/* Speed Slider */}
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>
                      Speech Speed: {speed}x
                    </Typography>
                    <Box pl="20px" pr="15px">
                      <Slider
                        value={speed}
                        onChange={(e, newValue) => setSpeed(newValue)}
                        min={0.25}
                        max={4}
                        step={0.25}
                        marks={[
                          { value: 0.25, label: "0.25x" },
                          { value: 4, label: "4x" },
                        ]}
                        valueLabelDisplay="auto"
                      />
                    </Box>
                  </Box>

                  {/* Generate Button */}
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={generateAudio}
                    disabled={isGenerating || text.length == 0 || text.length > 10000 }
                    startIcon={
                      isGenerating ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <MicIcon />
                      )
                    }
                    sx={{ height: 48 }}
                  >
                    {isGenerating ? "Generating..." : "Generate Speech"}
                  </Button>
                </Box>
              </Card>
              { voiceOverDetails && voiceOverDetails.status == 'pending' &&
                <Alert severity="info" sx={{ mb: 4 }}>
                  {/* No voice-over finalized. Select a voice-over from the list. */}
                  Your generated voice-over is being processed. This may take a few minutes. Please be patient.
                </Alert>
              }
            </Box>
          )}
        </>
      )}
      {projectDetail && projectDetail?.approvedVoiceOverFileId ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            sx={{
              border: "1px solid #80808047",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: 2,
              borderRadius: 2,
              boxShadow: 3,
              backgroundColor: "#f9f9f9",
              maxWidth: 400,
            }}
          >
            <Box mb={"30px"}>
              <Typography variant={"h4"}>Voice Over:</Typography>
            </Box>
            <Box>
              <img src="/images/audio-player-images.png" />
            </Box>
            <Box>
              {projectDetail?.approvedVoiceOverFileId && (
                <audio controls key={projectDetail.approvedVoiceOverFileId}>
                  <source
                    src={`${projectDetail.approvedVoiceOverFileId}?t=${Date.now()}`}
                    type="audio/mpeg"
                  />
                  Your browser does not support the audio element.
                </audio>
              )}
              {/* <audio controls>
                <source
                  src={projectDetail.approvedVoiceOverFileId}
                  type="audio/mpeg"
                />
                Your browser does not support the audio element.
              </audio> */}
            </Box>
          </Box>
        </Box>
      ) : (
        <Box>
          {/* <Typography>Voice over not found</Typography> */}
          {userDetails && userDetails.role == "admin" ? (
            <>
              {tabIndex == 1 &&
                (
                  <Box>
                    { !voiceOverDetails || voiceOverDetails.status == 'failed' && 
                        <Alert severity="info">
                          {/* No voice-over finalized. Select a voice-over from the list. */}
                          No voice-over generated yet. Enter your text above, then click "Generate Speech".
                        </Alert>
                    }
                  </Box>
                ) 
              }
              
              {tabIndex == 0 && <Alert severity="info">
                No voice-over uploaded. Drag and drop a file or click "Upload" to
                add one.
              </Alert>}
            </>
          ) : (
            <Alert severity="info">
              No voice-over uploaded yet! Waiting for the editor to add one.
            </Alert>
          )}
        </Box>
      )}
    </>
  );
};

export default CreateVoiceOverStage;
